import React from 'react'

function Footwear() {
  return (
    <div>Footwear</div>
  )
}

export default Footwear